import { http_client } from "@/plugins/http_client";

const obtenerDescuentos = async (params) =>
  http_client("/api/configuraciones-adicionales/descuentos", params, "get");

const guardarDescuento = async (body) =>
  http_client("/api/configuraciones-adicionales/descuento", body, "post");

const editarDescuento = async (id, body) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}`, body, "POST");

const cambiarEstadoDescuento = async (id) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/desactivar`, {}, "put");

const obtenerHistorial = async (id) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/historial`, {}, "get");

const obtenerEmpleadosDescuento = async (params) =>
  http_client(`/api/configuraciones-adicionales/empleados`, params, "get");

const obtenerEmpleadosAsignados = async (id, params) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/empleados`, params, "get");

const obtenerEmpleadoDetalle = async (id) =>
  http_client(`/api/configuraciones-adicionales/empleado/${id}`, {}, "get");

const asignarEmpleadoDescuento = async (id, body) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/empleados`, body, "post");

const removerEmpleadosDescuento = async (id, body) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/empleados`, body, "delete");

const editarEmpleadoMonto = async (id, body) =>
  http_client(`/api/configuraciones-adicionales/descuento/${id}/empleado`, body, "put");

//Catalogos
const obtenerAcreedores = async (params) =>
  http_client("/api/configuraciones-adicionales/acreedores", {}, "get");

const obtenerBancos = async (params) =>
  http_client("/api/configuraciones-adicionales/bancos", {}, "get");

const obtenerUnidades = async (params) =>
  http_client("/api/configuraciones-adicionales/unidades", {}, "get");

export default {
  obtenerDescuentos,
  guardarDescuento,
  editarDescuento,
  cambiarEstadoDescuento,
  obtenerHistorial,
  obtenerAcreedores,
  obtenerBancos,
  obtenerUnidades,
  obtenerEmpleadosDescuento,
  obtenerEmpleadosAsignados,
  obtenerEmpleadoDetalle,
  asignarEmpleadoDescuento,
  removerEmpleadosDescuento,
  editarEmpleadoMonto,
};